import React, { useState } from "react";

import "./_hisv4-billing.scss";
import "./_hisv4-billing-wallet.scss";

// Types
export type BillingTabKey = "pending" | "history" | "wallet";

type CardBillingV4Props = {
  // data
  encounterNumber: string;
  // render
  renderTab: (key: BillingTabKey) => React.ReactNode;
};

// Consts
const TABS: { key: BillingTabKey; label: string }[] = [
  { key: "pending", label: "รายการรอรับชำระเงิน" },
  { key: "history", label: "ประวัติชำระค่าบริการ" },
  { key: "wallet", label: "Wallet" },
];

/** สรุปค่าใช้จ่าย: แถบแท็บการเงิน + หัวหน้าของแท็บรายการรอรับชำระ */
const CardBillingV4 = (props: CardBillingV4Props) => {
  const [tab, setTab] = useState<BillingTabKey>("pending");

  // Handler
  const handleChangeTab = (key: BillingTabKey) => {
    setTab(key);
  };

  // Render
  return (
    <div className="hv4-bill">
      <div className="hv4-bill-tabs" role="tablist" aria-label="เมนูการเงิน">
        {TABS.map((item) => (
          <button
            key={item.key}
            type="button"
            role="tab"
            aria-selected={item.key === tab}
            className={`hv4-bill-tab${item.key === tab ? " hv4-bill-tab--on" : ""}`}
            onClick={() => handleChangeTab(item.key)}
          >
            {item.label}
          </button>
        ))}
      </div>
      {tab === "pending" && (
        <div className="hv4-bill-head">
          <h1 className="hv4-bill-h1">สรุปค่าใช้จ่าย</h1>
          <div className="hv4-bill-sub">
            <span>Encounter {props.encounterNumber}</span>
          </div>
        </div>
      )}
      <div className="hv4-bill-body" role="tabpanel">
        {props.renderTab(tab)}
      </div>
    </div>
  );
};

CardBillingV4.displayName = "CardBillingV4";

export default CardBillingV4;
